import __request__ from "routing/request";
export function getStatus() {
  return __request__("GET", "/system/processing/status", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getPersistedStatus() {
  return __request__("GET", "/system/processing/status/persisted", null, {}, {
    "Accept": ["application/json"]
  });
}
